import { api } from "..";

import { QueryProps } from "@/types/Api";
import {
  CreditFeature,
  CreditTier,
  UpdateCreditTierPayload,
} from "@/types/CreditTier";

export interface UpdateCreditTierParams {
  id: number;
  feature: CreditFeature;
  payload: UpdateCreditTierPayload;
}

export const updateCreditTier = async (
  props: QueryProps<UpdateCreditTierParams>
): Promise<CreditTier> => {
  const res = await api.client.patch(
    `/credit-tiers/${props.params.id}`,
    props.params.payload,
    {
      signal: props.signal,
      params: { feature: props.params.feature },
    }
  );
  return res.data;
};
